/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="57.5"
        height="95.58"
        viewBox="0 0 57.5 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M10.81 40.48a33.39 33.39 0 0 0-6.82.91c-.86.2-1.66.41-2.38.63l-.48.14-.45.15a1 1 0 0 0-.63 1.27v.09l.22.44.11.23c2.64 5.2 6.19 9.85 10.26 11.66 4.49 1.92 9.54.28 11.26-3.75s-.58-8.82-5.07-10.73a14.6 14.6 0 0 0-6.02-1.04Zm0 2a12.87 12.87 0 0 1 5.25.83c3.52 1.5 5.28 5.15 4 8.1s-5.11 4.21-8.63 2.7l-.3-.13c-3.23-1.53-6.23-5.4-8.54-9.73l-.21-.39.61-.17c.45-.12.92-.24 1.41-.35a31.08 31.08 0 0 1 6.44-.86Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M14.81 48.34a1 1 0 0 1 1.29-.57l.28.11.55.23.21.09c.81.36 1.71.79 2.68 1.3a49.7 49.7 0 0 1 8.13 5.25c.48.38 1 .78 1.42 1.18a1 1 0 0 1-1.31 1.51c-.44-.39-.9-.76-1.36-1.13a47.22 47.22 0 0 0-7.8-5c-.77-.4-1.5-.76-2.17-1.06l-.56-.25-.63-.26-.15-.06a1 1 0 0 1-.6-1.28.14.14 0 0 1 0-.06ZM46.74 36.48a14.51 14.51 0 0 0-6.11 1c-4.46 2-6.72 6.77-5 10.78s6.84 5.6 11.3 3.64a17.83 17.83 0 0 0 6.68-5.9 40.48 40.48 0 0 0 2.78-4.42l.17-.31.31-.59.34-.68.2-.44a1 1 0 0 0-.5-1.33h-.09l-.43-.13-.48-.14c-.7-.2-1.49-.4-2.33-.59a33.52 33.52 0 0 0-6.84-.89Zm0 2a31.19 31.19 0 0 1 6.45.8l.47.11.91.22.55.15-.14.27c-.09.19-.2.38-.31.58a37.22 37.22 0 0 1-2.63 4.19 15.64 15.64 0 0 1-5.85 5.31c-3.5 1.55-7.37.34-8.66-2.6s.42-6.61 3.93-8.15a12.76 12.76 0 0 1 5.26-.88Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M42.89 43.55a1 1 0 0 1 1.24.68 1 1 0 0 1-.69 1.23h-.16l-.38.12-.33.12c-.72.25-1.52.56-2.39.93a38 38 0 0 0-7.24 4.1 31 31 0 0 0-3.62 3.06 1 1 0 0 1-1.41-1.41 33.27 33.27 0 0 1 3.85-3.27 40.11 40.11 0 0 1 7.63-4.31c.76-.33 1.47-.61 2.13-.85l.71-.25.39-.13ZM28.71 0a17.32 17.32 0 1 0 17.32 17.34A17.31 17.31 0 0 0 28.71 0Zm0 2.5a14.82 14.82 0 1 1-14.82 14.84A14.81 14.81 0 0 1 28.71 2.52Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M28.61 32.13a1.26 1.26 0 0 1 1.24 1.13v30.92a1.24 1.24 0 0 1-1.18 1.31 1.25 1.25 0 0 1-1.32-1.15v-31a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M53.83 63.15a1.25 1.25 0 0 1 .12 2.49H2.13a1.25 1.25 0 0 1-1.18-1.3 1.24 1.24 0 0 1 1.09-1.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M50 64.06a1.25 1.25 0 1 1 2.44.55v.13l-7.55 27a5 5 0 0 1-5.1 3.83h-23a5.4 5.4 0 0 1-4-1.69l-.18-.18a6.12 6.12 0 0 1-1.1-1.7l-.07-.18-8-27a1.25 1.25 0 0 1 2.35-.84v.13l8 27a3.56 3.56 0 0 0 .62 1 2.89 2.89 0 0 0 2.07 1h23.19a2.91 2.91 0 0 0 1.45-.29 2.52 2.52 0 0 0 1.22-1.51l.07-.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M30.89 20.79a1.53 1.53 0 0 1-1.22 1.52 4.78 4.78 0 0 1-1 .1 2.38 2.38 0 0 1-2.44-1.78c-.07-.21-.12-.43-.18-.67l-2.9.75a6.14 6.14 0 0 0 1.46 2.87 4.92 4.92 0 0 0 3.18 1.47v2.29h1.82v-2.22c.38-.08.74-.14 1.1-.23a4.34 4.34 0 0 0 3-2.47 5 5 0 0 0 .35-3 4 4 0 0 0-2-2.87 22.11 22.11 0 0 0-2.78-1.22c-.57-.22-1.12-.48-1.67-.75a1.24 1.24 0 0 1-.62-.76 1.68 1.68 0 0 1 1.1-2.11h.08a2 2 0 0 1 1.94.5 3.58 3.58 0 0 1 .84 1.13l.19.44 2.59-1.08a5.28 5.28 0 0 0-.95-2 4.55 4.55 0 0 0-3.17-1.62V7.34h-1.84v1.73l-.27.05h-.27a4.13 4.13 0 0 0-3.13 2.54 5.14 5.14 0 0 0-.36 2.36 4.07 4.07 0 0 0 2.17 3.45 17.46 17.46 0 0 0 1.82.82"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'PottedPlantWithDollarSignCircleIcon';

export default Icon;
